export enum SmsTypeEnum {
    MOPS = "MOPS",
    MOS = "MOS",
    MOSNMO = "MOSNMO",
    MOSI = "MOSI",
    MTPS = "MTPS",
    MTS = "MTS",
    ROS = "ROS",
    RTS = "RTS"
}